module.exports = __webpack_public_path__ + "static/media/external-link-ltr-icon.07557fd7.svg";